import { TFunction } from 'i18next';
import { BULK_MESSAGING_BASE_PATH } from '@modules/bulk-messaging/bulk-messaging.constants';

export interface UserGuideTourStep {
  key: string;
  tourId: string;
  title: string;
  description: string;
  route?: string;
  openProfileDropdown?: boolean;
}

export const USER_GUIDE_TOUR_TOTAL_STEPS = 11;

export const userGuideTourSteps = (t: TFunction, tourGuideEnabled: boolean): UserGuideTourStep[] => {
  const steps: UserGuideTourStep[] = [
    {
      key: 'dashboard',
      tourId: 'dashboard',
      title: t('user_guide_module_dashboard_title'),
      description: t('user_guide_tour_dashboard_description'),
      route: '/dashboard',
    },
    {
      key: 'ai_assistance',
      tourId: 'ai_assistance',
      title: t('user_guide_module_ai_assistance_title'),
      description: t('user_guide_tour_ai_assistance_description'),
      route: '/ai-assistance/ai-voice-agent',
    },
    {
      key: 'analytics',
      tourId: 'analytics',
      title: t('user_guide_module_analytics_title'),
      description: t('user_guide_tour_analytics_description'),
      route: '/analytics/ai-dashboard',
    },
    {
      key: 'contacts',
      tourId: 'contacts',
      title: t('user_guide_module_contacts_title'),
      description: t('user_guide_tour_contacts_description'),
      route: '/contacts',
    },
    {
      key: 'bulk_messaging',
      tourId: 'bulk_messaging',
      title: t('user_guide_module_bulk_messaging_title'),
      description: t('user_guide_tour_bulk_messaging_description'),
      route: BULK_MESSAGING_BASE_PATH,
    },
    {
      key: 'power_dialer',
      tourId: 'power_dialer',
      title: t('user_guide_module_power_dialer_title'),
      description: t('user_guide_tour_power_dialer_description'),
    },
    {
      key: 'settings',
      tourId: 'settings',
      title: t('user_guide_module_settings_title'),
      description: t('user_guide_tour_settings_description'),
      route: '/settings/my-profile',
    },
    {
      key: 'load_wallet',
      tourId: 'load_wallet',
      title: t('user_guide_module_load_wallet_title'),
      description: t('user_guide_tour_load_wallet_description'),
      route: '/settings/wallet?tab=Overview',
    },
    {
      key: 'purchase_number',
      tourId: 'purchase_number',
      title: t('user_guide_module_purchase_number_title'),
      description: t('user_guide_tour_purchase_number_description'),
      route: '/settings/my-numbers',
    },
    {
      key: 'invite_members',
      tourId: 'invite_members',
      title: t('user_guide_module_invite_members_title'),
      description: t('user_guide_tour_invite_members_description'),
      route: '/settings/members',
    },
    {
      key: 'add_call_setting',
      tourId: 'add_call_setting',
      title: t('user_guide_module_add_call_setting_title'),
      description: t('user_guide_tour_add_call_setting_description'),
      route: '/settings/call-settings',
    },
    {
      key: 'add_payment_method',
      tourId: 'add_payment_method',
      title: t('user_guide_module_add_payment_method_title'),
      description: t('user_guide_tour_add_payment_method_description'),
      route: '/settings/payment-methods',
    },
    {
      key: 'user_guide',
      tourId: 'user_guide',
      title: t('user_guide_module_user_guide_title'),
      description: t('user_guide_tour_user_guide_description'),
      openProfileDropdown: true,
    },
  ];

  return steps.filter((step) => tourGuideEnabled || step.key !== 'user_guide');
};
